import { ColorValueStrict } from 'fronton-react';
import { KITCHEN_CALCULATOR_HREF, KITCHEN_ELEMENT_BLOCK } from '../kitchen-constants';
import { KitchenAdditionalItemStructure } from './old-kitchen-types';

export const KITCHEN_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/kitchen';

export const KITCHEN_PURE_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/kitchen';

export const KITCHEN_LANDING_NAME = 'kitchen';

export const NEW_PROJECT_HREF = 'https://kuhni3d.leroymerlin.ru/index.html#projects/anonymous/design';

export const READY_PROJECT_HREF = 'https://kuhni3d.leroymerlin.ru/index.html#inspiration/presetsStyles';

export const KITCHEN_HEADER_IMAGE_LIST = [
  {
    ldSrcSet: `${KITCHEN_CDN_PATH}/header/1-ld.jpg/1-ld.jpg`,
    dSrcSet: `${KITCHEN_CDN_PATH}/header/1-d.jpg/1-d.jpg`,
    tSrcSet: `${KITCHEN_CDN_PATH}/header/1-t.jpg/1-t.jpg`,
    mSrcSet: `${KITCHEN_CDN_PATH}/header/1-m.jpg/1-m.jpg`,
    title: 'Бесплатный проект кухни в светлых тонах',
    alt: 'Бесплатный проект кухни в светлых тонах',
  },
  {
    ldSrcSet: `${KITCHEN_CDN_PATH}/header/2-ld.jpg/2-ld.jpg`,
    dSrcSet: `${KITCHEN_CDN_PATH}/header/2-d.jpg/2-d.jpg`,
    tSrcSet: `${KITCHEN_CDN_PATH}/header/2-t.jpg/2-t.jpg`,
    mSrcSet: `${KITCHEN_CDN_PATH}/header/2-m.jpg/2-m.jpg`,
    title: 'Дерево в интерьере кухни',
    alt: 'Дерево в интерьере кухни',
  },
  {
    ldSrcSet: `${KITCHEN_CDN_PATH}/header/3-ld.jpg/3-ld.jpg`,
    dSrcSet: `${KITCHEN_CDN_PATH}/header/3-d.jpg/3-d.jpg`,
    tSrcSet: `${KITCHEN_CDN_PATH}/header/3-t.jpg/3-t.jpg`,
    mSrcSet: `${KITCHEN_CDN_PATH}/header/3-m.jpg/3-m.jpg`,
    title: 'Проект кухни в тёмных тонах',
    alt: 'Проект кухни в тёмных тонах',
  },
];

export const KITCHEN_ADDITIONAL_BASE_LIST: KitchenAdditionalItemStructure[] = [
  {
    name: 'Бытовая техника для\u00A0кухни',
    imgSrc: `${KITCHEN_CDN_PATH}/categories/appliances.png/appliances.png`,
    alt: 'Холодильник',
    link: {
      href: '/catalogue/bytovaya-tehnika-dlya-kuhni/',
      title: 'Бытовая техника для кухни',
    },
  },
  {
    name: 'Мойки и\u00A0смесители для\u00A0кухни',
    imgSrc: `${KITCHEN_CDN_PATH}/categories/sinks.png/sinks.png`,
    alt: 'Мойка',
    link: {
      href: '/catalogue/moyki-i-smesiteli-dlya-kuhni/',
      title: 'Мойки и смесители для кухни',
    },
  },
  {
    name: 'Кухонные аксессуары',
    imgSrc: `${KITCHEN_CDN_PATH}/categories/accessories.png/accessories.png`,
    alt: 'Кухонные аксессуары',
    link: {
      href: '/catalogue/kuhonnye-aksessuary/',
      title: 'Кухонные аксессуары',
    },
  },
  {
    name: 'Посуда',
    imgSrc: `${KITCHEN_CDN_PATH}/categories/tableware.png/tableware.png`,
    alt: 'Посуда',
    link: {
      href: '/catalogue/posuda-dlya-servirovki/',
      title: 'Посуда для сервировки',
    },
  },
  {
    name: 'Кухонные столы',
    imgSrc: `${KITCHEN_CDN_PATH}/categories/tables.png/tables.png`,
    alt: 'Кухонный стол',
    link: {
      href: '/catalogue/kuhonnye-stoly/',
      title: 'Кухонные столы',
    },
  },
  {
    name: 'Столешницы',
    imgSrc: `${KITCHEN_CDN_PATH}/categories/countertops.png/countertops.png`,
    alt: 'Столешница',
    link: {
      href: '/catalogue/stoleshnicy-i-komplektuyushchie/',
      title: 'Столешницы',
    },
  },
  {
    name: 'Стеновые панели',
    imgSrc: `${KITCHEN_CDN_PATH}/categories/wall-panels.png/wall-panels.png`,
    alt: 'Стеновые панели',
    link: {
      href: '/catalogue/stenovye-paneli-dlya-kuhni/',
      title: 'Стеновые панели для кухни',
    },
  },
  {
    name: 'Барные стойки и\u00A0аксессуары',
    imgSrc: `${KITCHEN_CDN_PATH}/categories/bar-counters.png/bar-counters.png`,
    alt: 'Барная стойка',
    link: {
      href: '/catalogue/barnye-stoyki-i-aksessuary/',
      title: 'Барные стойки и аксессуары',
    },
  },
];

export const KITCHEN_ADDITIONAL_CATALOG_LIST: KitchenAdditionalItemStructure[] = [
  ...KITCHEN_ADDITIONAL_BASE_LIST,
  {
    name: 'Модульные кухни',
    imgSrc: `${KITCHEN_CDN_PATH}/categories/modular-kitchens.png/modular-kitchens.png`,
    alt: 'Модульный шкаф кухни',
    link: {
      href: '/catalogue/modulnye-kuhni/',
      title: 'Модульные кухни',
    },
  },
  {
    name: 'Мебель для\u00A0кухни',
    imgSrc: `${KITCHEN_CDN_PATH}/categories/furniture.png/furniture.png`,
    alt: 'Мебель для кухни',
    link: {
      href: '/catalogue/mebel-dlya-kuhni/',
      title: 'Мебель для кухни',
    },
  },
];

export const KITCHEN_ADDITIONAL_MODULAR_LIST: KitchenAdditionalItemStructure[] = [
  ...KITCHEN_ADDITIONAL_BASE_LIST,
  {
    name: 'Модульные кухни',
    imgSrc: `${KITCHEN_CDN_PATH}/categories/modular-kitchens.png/modular-kitchens.png`,
    alt: 'Модульный шкаф кухни',
    link: {
      href: '/proekt-kuhni/gotovye/',
      title: 'Модульные кухни',
    },
  },
  {
    name: 'Мебель для\u00A0кухни',
    imgSrc: `${KITCHEN_CDN_PATH}/categories/furniture.png/furniture.png`,
    alt: 'Мебель для кухни',
    link: {
      href: '/catalogue/mebel-dlya-kuhni/',
      title: 'Мебель для кухни',
    },
  },
];

export const KITCHEN_RENOVATION = {
  bgColor: '#A0B9B1',
  elementBlock: KITCHEN_ELEMENT_BLOCK,
  content: {
    media: {
      alt: 'Онлайн-калькулятор кухни',
      srcD: `${KITCHEN_CDN_PATH}/banners/calculator-icon-d.png/calculator-icon-d.png`,
      srcT: `${KITCHEN_CDN_PATH}/banners/calculator-icon-t.png/calculator-icon-t.png`,
      src: `${KITCHEN_CDN_PATH}/banners/calculator-icon-m.png/calculator-icon-m.png`,
    },
    title: 'Онлайн-калькулятор кухни',
    text: 'Узнайте примерную стоимость кухни с\u00A0помощью нашего онлайн-калькулятора',
    textColor: 'text-primary' as ColorValueStrict,
  },
  link: {
    href: KITCHEN_CALCULATOR_HREF,
    title: 'Онлайн-калькулятор кухни',
    target: '_blank',
  },
  promotion: {
    name: KITCHEN_ELEMENT_BLOCK,
    creative: 'Онлайн-калькулятор кухни',
    position: '1',
  },
};
